import {
  Theme,
  color,
  optionStyles,
  propertyColorStyles,
  spacing,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { PropertyColor } from '@thiememeulenhoff/types';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('checkbox');
export const theme = new Theme(tag);

const propertyColorCallback = (
  propertyColor: PropertyColor,
  propertyAltColor: PropertyColor,
) => {
  const selector = unsafeCSS(`[color=${propertyColor}]`);

  return css`
    :host(${selector}) :where(input):not([disabled]):checked {
      background-color: ${color(propertyColor)};
      border-color: ${color(propertyColor)};
    }

    :host(${selector}) :where(input):not([disabled]):checked + .icon {
      color: ${color(propertyAltColor)};
    }

    @media (hover: hover) {
      :host(${selector}) :where(input):not([disabled]):hover {
        border-color: ${color(propertyColor)};
      }
    }
  `;
};

const propertyColorStyle = propertyColorStyles(propertyColorCallback);

export const styles = [
  optionStyles,
  css`
    :where(label) {
      align-items: center;
      display: flex;
      gap: ${spacing(100)};
      justify-content: flex-start;
    }

    :where(.input) {
      display: grid;
      flex: 0;
      place-items: center;
    }

    :where(input, .icon) {
      grid-area: 1 / 1;
    }

    :where(.icon) {
      align-items: center;
      color: transparent;
      display: flex;
      justify-content: center;
      pointer-events: none;
    }

    :where(input):checked + .icon,
    :where(input):indeterminate + .icon {
      color: ${token('text-inverted')};
    }

    :where(input):indeterminate {
      background-color: ${token('background-interactive')};
      border-color: ${token('border-interactive')};
    }

    :host([error]) :where(input) {
      border-color: ${token('input-border-error')};
    }

    :host([disabled]) {
      color: ${token('foreground-disabled')};
      :where(input):checked {
        background-color: ${token('background-disabled')};
        border-color: ${token('border-disabled')};
      }
      :where(input):checked + .icon {
        color: ${token('foreground-disabled')};
      }
    }
  `,
  propertyColorStyle,
];
